import { gql } from "@apollo/client";

export default gql`
  mutation deleteTeamsNotificationForChannelMutation($notificationId: Int!) {
    deleteTeamsNotificationForChannel(notificationId: $notificationId) {
      organization {
        id
        teamsNotifications {
          edges {
            node {
              id
              teamId
              teamName
              channelId
              channelName
              recognitions
              goalCheckins
            }
          }
        }
      }
    }
  }
`;
